import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./components/dashboard/dashboard";
import { Navigate } from "react-router-dom";

//Login
import Login from "./components/login/login";

//Forgot Password
import ForgotPassword from "./components/login/forgotPassword.js";

// Import your new PrivateRoute component
import PrivateRoute from "./privateRoute.js";

//MatchSeeker Imports
import MatchSeekerListing from "./components/matchSeekers/listing";
import EditMatchSeeker from "./components/matchSeekers/edit";
import AddMatchSeeker from "./components/matchSeekers/add";
import ViewMSSubscriptions from "./components/matchSeekers/viewSubscriptiondetails.js";
import ViewMatchSeekerDetails from "./components/matchSeekers/view.js";

//Bg profiles Imports
import ProfilesListing from "./components/bgprofiles/list";
import AddBrideGroomProfile from "./components/bgprofiles/add";
import ViewBgProfileDetails from "./components/bgprofiles/view.js";

// SAM imports
import StaffAccessManagamentListing from "./components/staffAccessManagement/list";
import AddStaffAccount from "./components/staffAccessManagement/add";
import ViewStaffAccount from "./components/staffAccessManagement/view.js";

//No page Found
import PageNotFound from "./components/pageNotFound/pageNotFound.js";

// Master Data Management
import MasterDataListing from "./components/masterDataManagement/masterDataList.js";
import ModelListing from "./components/masterDataManagement/masterDataModelList.js";
import AddEditMasterData from "./components/masterDataManagement/masterDataAdd&edit.js";

//Logs
import SupportListing from "./components/logs/support/list.js";

//payments
import PackPurchasesList from "./components/packPurchases/list.js";
import PackPurchaseDetail from "./components/packPurchases/detail.js";

//Layout
import Layout from "./components/dashboard/layout.js";

//Reports
import Reports from "./components/reports/list.js";

//Verification Requests
import VerificationRequests from "./components/verificationRequests/list.js";
import SubscriptionsListing from "./components/subscriptions/list.js";
import ViewSubscriptionDetails from "./components/subscriptions/view.js";
import CommandDashboard from "./components/dashboard/command-dashboard.js";
import BroadcastNotifications from "./components/notifications/broadcast.js";
import NotificationsHub from "./components/notifications/NotificationsHub.js";
import PromoCodeList from "./components/promoCodes/list.js";
import AppConfigList from "./components/appConfig/list.js";
import AuditLogList from "./components/auditLog/list.js";
import InfluencerHub from "./components/influencer/InfluencerHub.js";
import InfluencerDetail from "./components/influencer/InfluencerDetail.js";
import InfluencerPublicView from "./components/influencer/InfluencerPublicView.js";
import PricingDashboard from "./components/pricingDashboard/index.js";
import BoostConsole from "./components/boostConsole/index.js";
import AlignmentQuestions from "./components/alignmentQuestions/index.js";
import NotificationTriggers from "./components/notifications/triggers.js";
import UserPackManager from "./components/userPackManager/index.js";

//MatchMatrix Bureau (matchmaker rails)
import BureauListing from "./components/bureau/listing.js";
import ViewBureau from "./components/bureau/view.js";
import BureauIntakes from "./components/bureau/intakes.js";
import ConsentLookup from "./components/bureau/consent.js";
import Referrals from "./components/bureau/referrals.js";

//Events
import EventsListing from "./components/events/listing.js";
import AddEvent from "./components/events/add.js";
import EditEvent from "./components/events/edit.js";
import ViewEvent from "./components/events/view.js";
import MatchmakerEarnings from "./components/events/earnings.js";
import PaymentReconciliation from "./components/paymentReconciliation/index.js";
import SubscriptionExpiry from "./components/subscriptionExpiry/index.js";
import ConnectsList from "./components/connects/list.js";
import MatchLog from "./components/matchLog/index.js";
import MatchClosures from "./components/matchClosures/index.js";
import FraudDetection from "./components/fraudDetection/index.js";
import PackUsers from "./components/packUsers/index.js";
import SecondMarriagePool from "./components/secondMarriagePool/index.js";
import UserDeepDive from "./components/userDeepDive/index.js";
import GlobalSearch from "./components/globalSearch/index.js";
import EngagementAnalytics from "./components/engagementAnalytics/index.js";
import PhotoModeration from "./components/photoModeration/index.js";
import StatusAnalytics from "./components/statusAnalytics/StatusAnalytics.js";
import StatusManager from "./components/statusManager/StatusManager.js";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" index element={<Login />} />
        <Route path="/forgot-pwd" element={<ForgotPassword />} />

        {/* Protected Routes */}
        <Route path="/" element={<PrivateRoute element={<Layout />} />}>
          <Route index element={<Navigate to="command-dashboard" replace />} />

          <Route
            path="dashboard"
            element={<Navigate to="/command-dashboard" replace />}
          />

          <Route path="user-management">
            <Route path="match-seekers">
              <Route
                path="list"
                element={<PrivateRoute element={<MatchSeekerListing />} />}
              />
              <Route
                path="add"
                element={<PrivateRoute element={<AddMatchSeeker />} />}
              />
              <Route
                path="edit/:id"
                element={<PrivateRoute element={<EditMatchSeeker />} />}
              />

              <Route
                path="view-subscription-details"
                element={<PrivateRoute element={<ViewMSSubscriptions />} />}
              />

              <Route
                path="view/:id"
                element={<PrivateRoute element={<ViewMatchSeekerDetails />} />}
              />
            </Route>

            <Route path="bride-groom-profile">
              <Route
                path="list"
                element={<PrivateRoute element={<ProfilesListing />} />}
              />
              <Route
                path="add"
                element={<PrivateRoute element={<AddBrideGroomProfile />} />}
              />
              <Route
                path="edit/:id"
                element={
                  <PrivateRoute
                    element={<AddBrideGroomProfile type={"edit"} />}
                  />
                }
              />
              <Route
                path="view/:id"
                element={<PrivateRoute element={<ViewBgProfileDetails />} />}
              />
            </Route>
            <Route path="reports">
              <Route
                path="list"
                element={<PrivateRoute element={<Reports />} />}
              />
            </Route>

            <Route path="verification">
              <Route
                path="list"
                element={<PrivateRoute element={<VerificationRequests />} />}
              />
            </Route>
          </Route>

          <Route path="staff-access-management">
            <Route
              path="list"
              element={
                <PrivateRoute element={<StaffAccessManagamentListing />} />
              }
            />
            <Route
              path="add"
              element={<PrivateRoute element={<AddStaffAccount />} />}
            />
            <Route
              path="edit/:id"
              element={
                <PrivateRoute element={<AddStaffAccount type={"edit"} />} />
              }
            />
            <Route
              path="view/:id"
              element={<PrivateRoute element={<ViewStaffAccount />} />}
            />
          </Route>

          <Route path="master-data-management">
            <Route
              path="list"
              element={<PrivateRoute element={<MasterDataListing />} />}
            />
            <Route
              path="modellist/:modelname"
              element={<PrivateRoute element={<ModelListing />} />}
            />
            <Route
              path="edit/:modelname/:itemId"
              element={
                <PrivateRoute element={<AddEditMasterData type="edit" />} />
              }
            />

            <Route
              path="add/:modelname"
              element={<PrivateRoute element={<AddEditMasterData />} />}
            />
          </Route>

          <Route path="logs">
            <Route path="support">
              <Route
                path="list"
                element={<PrivateRoute element={<SupportListing />} />}
              />
            </Route>
          </Route>

          <Route path="payments">
            <Route path="pack-purchases">
              <Route
                path="list"
                element={<PrivateRoute element={<PackPurchasesList />} />}
              />
              <Route
                path="detail/:id"
                element={<PrivateRoute element={<PackPurchaseDetail />} />}
              />
            </Route>
          </Route>

          <Route path="manage-subscription">
            <Route
              path="list"
              element={<PrivateRoute element={<SubscriptionsListing />} />}
            />
            <Route
              path="view"
              element={<PrivateRoute element={<ViewSubscriptionDetails />} />}
            />
          </Route>

          <Route
            path="command-dashboard"
            element={<PrivateRoute element={<CommandDashboard />} />}
          />

          <Route path="notifications">
            <Route
              path="broadcast"
              element={<PrivateRoute element={<BroadcastNotifications />} />}
            />
            <Route
              path="hub"
              element={<PrivateRoute element={<NotificationsHub />} />}
            />
          </Route>

          <Route path="promo-codes">
            <Route
              path="list"
              element={<PrivateRoute element={<PromoCodeList />} />}
            />
          </Route>

          <Route path="bureau">
            <Route
              path="list"
              element={<PrivateRoute element={<BureauListing />} />}
            />
            <Route
              path="view/:id"
              element={<PrivateRoute element={<ViewBureau />} />}
            />
            <Route
              path="intakes"
              element={<PrivateRoute element={<BureauIntakes />} />}
            />
            <Route
              path="referrals"
              element={<PrivateRoute element={<Referrals />} />}
            />
            <Route
              path="consent"
              element={<PrivateRoute element={<ConsentLookup />} />}
            />
          </Route>

          <Route path="events">
            <Route
              path="list"
              element={<PrivateRoute element={<EventsListing />} />}
            />
            <Route
              path="add"
              element={<PrivateRoute element={<AddEvent />} />}
            />
            <Route
              path="edit/:id"
              element={<PrivateRoute element={<EditEvent />} />}
            />
            <Route
              path="view/:id"
              element={<PrivateRoute element={<ViewEvent />} />}
            />
            <Route
              path="earnings"
              element={<PrivateRoute element={<MatchmakerEarnings />} />}
            />
          </Route>

          <Route
            path="app-config"
            element={<PrivateRoute element={<AppConfigList />} />}
          />

          <Route
            path="audit-log"
            element={<PrivateRoute element={<AuditLogList />} />}
          />

          <Route path="influencer-hub">
            <Route index element={<PrivateRoute element={<InfluencerHub />} />} />
            <Route path=":promoId" element={<PrivateRoute element={<InfluencerDetail />} />} />
          </Route>

          <Route
            path="pricing-dashboard"
            element={<PrivateRoute element={<PricingDashboard />} />}
          />
          <Route
            path="boost-console"
            element={<PrivateRoute element={<BoostConsole />} />}
          />
          <Route
            path="alignment-questions"
            element={<PrivateRoute element={<AlignmentQuestions />} />}
          />
          <Route
            path="notification-triggers"
            element={<PrivateRoute element={<NotificationTriggers />} />}
          />
          <Route
            path="user-pack-manager"
            element={<PrivateRoute element={<UserPackManager />} />}
          />
          <Route
            path="payment-reconciliation"
            element={<PrivateRoute element={<PaymentReconciliation />} />}
          />
          <Route
            path="subscription-expiry"
            element={<PrivateRoute element={<SubscriptionExpiry />} />}
          />
          <Route path="connects">
            <Route
              path="list"
              element={<PrivateRoute element={<ConnectsList />} />}
            />
          </Route>
          <Route
            path="match-log"
            element={<PrivateRoute element={<MatchLog />} />}
          />
          <Route
            path="match-closures"
            element={<PrivateRoute element={<MatchClosures />} />}
          />
          <Route
            path="second-marriage-pool"
            element={<PrivateRoute element={<SecondMarriagePool />} />}
          />
          <Route
            path="pack-users"
            element={<PrivateRoute element={<PackUsers />} />}
          />
          <Route
            path="fraud-refunds"
            element={<PrivateRoute element={<FraudDetection />} />}
          />
          <Route
            path="user-deep-dive/:seekerId"
            element={<PrivateRoute element={<UserDeepDive />} />}
          />
          <Route
            path="global-search"
            element={<PrivateRoute element={<GlobalSearch />} />}
          />
          <Route
            path="engagement-analytics"
            element={<PrivateRoute element={<EngagementAnalytics />} />}
          />
          <Route
            path="status-analytics"
            element={<PrivateRoute element={<StatusAnalytics />} />}
          />
          <Route
            path="status-manager"
            element={<PrivateRoute element={<StatusManager />} />}
          />
          <Route
            path="photo-moderation"
            element={<PrivateRoute element={<PhotoModeration />} />}
          />
        </Route>

        {/* Public influencer view — no login required */}
        <Route path="/influencer/:token" element={<InfluencerPublicView />} />

        {/* Fallback Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
